__turbopack_context__.v({
  "title": "Collection-module-scss-module__PXuwRa__title",
});
